import { DIFFICULTY } from "../constants";
import { Answer, Content, Score } from "../types";

export function markAnswer(content: Content, answer: Answer): Score {
  if (!answer)
    return {
      score: 0
    };

  switch (answer.difficulty) {
    case DIFFICULTY.HARD:
      return {
        score: 0
      };

    case DIFFICULTY.OKAY:
      return {
        score: 0.5,
        avoidNegFeedback: true
      } as Score;

    case DIFFICULTY.EASY:
      return {
        score: 1
      };

    default:
      return null as unknown as Score;
  }
}
